import React from "react";

function ClientTab({ data = {}, onChange }) {
  const handleInput = (e) => {
    const { name, value } = e.target;
    onChange({ ...data, [name]: value });
  };

  return (
    <div className="bg-white p-3 rounded-md shadow-md border">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
        
        {/* Client Name */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Client Name</label>
          <input
            name="client_name"
            value={data.client_name || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Enter client name"
          />
        </div>

        {/* Contact Person Name */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Contact Person</label>
          <input
            name="contact_person"
            value={data.contact_person || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Enter Contact Person name"
          />
        </div>

        {/* Email */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Email</label>
          <input
            name="email"
            type="email"
            value={data.email || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Enter email"
          />
        </div>

        {/* Phone */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Phone</label>
          <input
            name="phone"
            value={data.phone || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Enter phone"
          />
        </div>

        {/* Address */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Address</label>
          <input
            name="address"
            value={data.address || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="Enter address"
          />
        </div>

        {/* Industry Type */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Industry Type</label>
          <input
            name="industry_type"
            value={data.industry_type || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="e.g. Construction"
          />
        </div>
      </div>
    </div>
  );
}

export default ClientTab;
